/**
 * Where the API lives. In dev, Vite proxies /api to the FastAPI server
 * (vite.config.ts). A production build or a Capacitor app sets VITE_API_BASE
 * to the API's full URL at build time.
 */
export const API_BASE: string = (import.meta.env.VITE_API_BASE as string | undefined) ?? "/api";
